export default "__VITE_ASSET__Dpe$Gzem__"